<ng-container *ngIf="total > 0">
    <ul class="pagination justify-content-center mb-0">
        <li class="page-item" *ngIf="array.length > 0">
            <button class="page-link" (click)="first.emit(1)" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
            </button>
        </li>
        <ng-container *ngFor="let pageNumber of array">
            <li class="page-item" *ngIf="pageNumber <= totalPage" [ngClass]="{'active': page == pageNumber}">
                <button class="page-link" (click)="change.emit(pageNumber)">
                    {{ pageNumber }}
                </button>
            </li>
        </ng-container>
        <li class="page-item" *ngIf="array.length > 0">
            <button class="page-link" (click)="last.emit(totalPage)" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
            </button>
        </li>
    </ul>
    <div class="text-center text-gray fs-8 mt-1">
        Página {{ page }} de {{ totalPage }} - Total de registros: {{ total }}
    </div>
</ng-container>
